import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'dhumanize',
  standalone: true
})
export class DhumanizePipe implements PipeTransform {
  transform(value: number): string | null {
    if (!value) {
      return null;
    }

    return moment.duration(value).humanize();
  }
}
